module.exports = __webpack_public_path__ + "media/images/guideline/F_01-0ea61372846b742b93276ffe59023c95.jpg";